import React from 'react';
import { InputField } from 'forms/fields';
import { Row, Col, Text, Heading } from 'mymoria-ui/components';
import DateInputField from 'forms/fields/DateInputField';
import { form } from 'data';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { styled } from 'mymoria-ui';
import { Poa } from 'types';
import StyledCard from 'components/StyledCard';
import { useHistory } from 'react-router-dom';
import { global as t } from 'data';

const StyledHeading = styled(Heading.Heading2)(`
  margin-top: 2rem;
`);

const { deceased, customer } = form;

const Flex = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const StyledImg = styled.img`
  margin-bottom: 5rem;
`;

const Summary = () => {
  const { values } = useFormikContext<Poa>();
  const history = useHistory();
  const sessionValues = sessionStorage.getItem('form-values-vollmacht-create-mode');

  if (isEmpty(sessionValues)) {
    history.push('/');
  }

  return (
    <StyledCard title={form.deceased.title}>
      <Row flexWrap="wrap">
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.firstName"
            label={deceased.firstName}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.lastName"
            label={deceased.lastName}
            validation={false}
          />
        </Col>

        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.maritalStatus"
            value={values.deceased.maritalStatus}
            placeholder={deceased.maritalState}
            label={deceased.maritalState}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <DateInputField
            readOnly
            name="deceased.birthDate"
            label={deceased.birthDate}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.birthPlace"
            label={deceased.birthPlace}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <DateInputField
            readOnly
            name="deceased.deathDate"
            label={deceased.deathDate}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.deathPlace"
            label={deceased.deathPlace}
            validation={false}
          />
        </Col>
        <Col width={1}>
          <Text>{deceased.lastLivingTitle}</Text>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.street"
            label={deceased.lastLivingStreet}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.houseNr"
            label={deceased.lastLivingHouseNr}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.code"
            label={deceased.lastLivingCode}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="deceased.place"
            label={deceased.lastLivingPlace}
            validation={false}
          />
        </Col>
      </Row>
      <Row flexWrap="wrap">
        <Col>
          <StyledHeading>{customer.title}</StyledHeading>
          <Text>{customer.text1}</Text>
          <Text mb="1.5rem">{customer.text2}</Text>
        </Col>

        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="customer.firstName"
            label={customer.firstName}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="customer.lastName"
            label={customer.lastName}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField readOnly name="customer.street" label={customer.street} validation={false} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField
            readOnly
            name="customer.houseNr"
            label={customer.houseNr}
            validation={false}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField readOnly name="customer.code" label={customer.code} validation={false} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField readOnly name="customer.place" label={customer.place} validation={false} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <DateInputField
            readOnly
            name="customer.birthDate"
            label={customer.birthDate}
            validation={false}
          />
        </Col>
        <Col width={1}>
          <InputField
            readOnly
            name="customer.relationship"
            label={customer.relationship}
            validation={false}
          />
        </Col>
        {values.customer?.phone && (
          <Col width={1}>
            <InputField readOnly name="customer.phone" label={customer.phone} validation={false} />
          </Col>
        )}
        {values.customer?.email && (
          <Col width={1}>
            <InputField readOnly name="customer.email" label={customer.email} validation={false} />
          </Col>
        )}
        <Col>
          <Flex>
            <Text>
              {values.signature?.place}
              {t.labels.the}
              {' ' + values.signature?.date}
            </Text>
          </Flex>
        </Col>
      </Row>
      <StyledImg width="50%" src={(values as Partial<Poa>).signature?.img} alt="Unterschrift" />
    </StyledCard>
  );
};

export default Summary;
